import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe } from '@angular/common';
export class ServicesStoreFeedback {
    constructor(
    ) {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.ConfigType.toLowerCase() == "form") {
            let request = JSON.parse(webcontext.RequestBody);

            if (typeof (request["a_FeedbackContent"]) == "undefined") {
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage = "请填写反馈信息";
            }
            let tbstore = JSON.parse(localStorage.getItem("tbstore")) || {};
            if(tbstore){
                request["a_FK_Store_ID"] = tbstore["ID"];
            }
            request["a_FK_FeedbackPerson_ID"] = webcontext.Account.Id;
            webcontext.RequestBody = JSON.stringify(request);
        }

        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        const that = this;
    if(webParameterContext.ConfigType.toLowerCase()=="form"){
     if(webContext.ResponseMessage.Success){
      let datepie:DatePipe =new DatePipe("en-US");
          if(webContext.Other){
           webContext.Other.Success=true;
            webContext.url="/tabs/contact/buttons/"+datepie.transform(new Date(),"yyyyMMddHHmmss");
          }else{
           webContext.Other={"Success":true,"url":"/tabs/contact/buttons/"+datepie.transform(new Date(),"yyyyMMddHHmmss")};
          }
     }
    
     // webContext.ResponseMessage.ErrorMessage="排版成功,请尽快联系上级领导审批通过后方可进入此系统";
     // webContext.ResponseMessage.Success=false;
    }

        return webContext
    }


}